export default {
  saleReturnList: [],
  saleReturnInfo: {},
  unClosedSaleReturnCount: 0,
  unPaidSaleReturnCount: 0,
  unClosedReportSaleReturnCount: 0,
  unPaidReportSaleReturnCount: 0
}
